import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { fetchSiteCopy } from "../api/fetchSiteCopy";
import { DEFAULT_SITE_COPY } from "../localeConfig";

const SiteCopyContext = createContext({
  copy: DEFAULT_SITE_COPY,
  loading: false,
  error: null,
});

export function SiteCopyProvider({ children }) {
  const { locale } = useParams();
  const [copy, setCopy] = useState(DEFAULT_SITE_COPY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const next = await fetchSiteCopy(locale);
        if (!cancelled) {
          setCopy(next);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) {
          setCopy(DEFAULT_SITE_COPY);
          setError(e);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [locale]);

  const value = useMemo(() => ({ copy, loading, error }), [copy, loading, error]);

  return (
    <SiteCopyContext.Provider value={value}>{children}</SiteCopyContext.Provider>
  );
}

export function useSiteCopy() {
  return useContext(SiteCopyContext);
}
